import { asString, isObject } from "./model-utils";

export class Currency {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.currencyId = asString(json.currencyId || json.name);
    this.name = asString(json.name);
    this.currency = asString(json.currency ?? json.code);
    this.symbol = asString(json.symbol);
  }

  static fromJson(json: any) {
    return isObject(json) ? new Currency(json) : json;
  }
}
